import { gql } from "@apollo/client";

// Mutation: Start a video render job
export const START_VIDEO_RENDER_MUTATION = gql`
  mutation StartVideoRender($input: StartVideoRenderInput!) {
    startVideoRender(input: $input) {
      renderId
      bucketName
      status
      message
    }
  }
`;

// Query: Check render progress
export const GET_RENDER_PROGRESS_QUERY = gql`
  query GetRenderProgress($input: GetRenderProgressInput!) {
    getRenderProgress(input: $input) {
      type
      progress
      url
      size
      message
      renderId
    }
  }
`;

// Query: Get render download URL
export const GET_RENDER_DOWNLOAD_URL_QUERY = gql`
  query GetRenderDownloadUrl($input: GetRenderDownloadUrlInput!) {
    getRenderDownloadUrl(input: $input) {
      downloadUrl
      expiresIn
    }
  }
`;
